
// BOB THE BUILDER ANALYTICS
const prefix = 'BTB:';
export const BTBA = {
  startTraining: `${prefix} Start Training`,
  finishTraining: `${prefix} Finish Training`,
  exitTraining: `${prefix} Exit Training`,
  enterPage: `${prefix} Enter page`,
  exitPage: `${prefix} Exit page`,
  resumeDialogAction: `${prefix} Resume Dialog Action`,
  changeVideoSetting: `${prefix} Change Video Setting`,
  finishedVideo: `${prefix} Finished Video`,
  startKnowledgeCheck: `${prefix} Start Knowledge Check`,
  finishedKnowledgeCheck: `${prefix} Finished Knowledge Check`,
  startQuizPool: `${prefix} Start Quiz Pool`,
  finishedQuizPool: `${prefix} Finished Quiz Pool`,
  openGlossaryTerm: `${prefix} Open Glossary Term`,
  searchGlossary: `${prefix} Search Glossary`
};

export interface FinishTrainingProperties {
  'Session Duration' : Number;
  'Success Status ' : string;
  'Complete Status' : string;
  'Final Score' : Number;
  'Minimum Score' : Number;
  'Maximum Score' : Number;
  'Scaled Score' : Number;
  'Is Sidebar Opened' : boolean;
  'Page ID' : string;
  'Page Title': string;
}
export interface ExitTrainingProperties extends FinishTrainingProperties {}

export interface EnterPageProperties {
  'Page ID': string;
  'Page Title': string;
  'Has Interactive': boolean;
  'Interactives': string[];
}
export interface ExitPageProperties extends EnterPageProperties{
  'In Page Duration': number;
  'Locked Page': boolean;
  'Time Until Unlock': number;
}

export interface ResumeTrainingProperties {
  'Page ID': string;
  'Page Title': string;
}

export interface ContinueTrainingProperties extends ResumeTrainingProperties {}

export interface VideoProperties {
  'Video SRC' : string;
  'Video Duration' : number;
  'Transcript Opened': boolean;
}


export interface ChangeVideoSettingProperties extends VideoProperties {
  'Changed Option' : string;
  'Selected Value' : string | number;
}

export interface FinishedVideoProperties extends VideoProperties {
  'Video Watched Time': number;
  'Video Caption': string;
  'Video Playback Speed': number;
}


export interface StartKnowledgeCheckProperties {
  'Page ID': string;
  'Page Title': string;
  'Knowledge Check Type': string;
  'Knowledge Check Instructions': string;
  'Quiz Question' ?: string;
}

export interface FinishedKnowledgeCheckProperties extends StartKnowledgeCheckProperties{
  'Got Right'?:boolean;
  'Chosen Answer'?:string[];
  'Duration':number;
}
export interface StartQuizPoolProperties {
  'Page ID': string;
  'Page Title': string;
  'Pool Size' : number;
}

export interface FinishedQuizPoolProperties extends StartQuizPoolProperties {
  'Final Score' : string;
  'Minimum Score' : number;
  'Maximum Score' : number;
  'Scaled Score' : number;
  'Duration' : number;
}

export interface OpenGlossaryTermProperties {
  'Glossary Term' : string;
  'Page ID' : string;
  'Page Title': string;
}

export interface SearchGlossaryTermProperties {
  'Glossary Query' : string;
  'Page ID' : string;
  'Page Title': string;
}



export type TrackProperties =
  | FinishTrainingProperties
  | ExitTrainingProperties
  | EnterPageProperties
  | ExitPageProperties
  | ResumeTrainingProperties
  | ContinueTrainingProperties
  | FinishedVideoProperties
  | ChangeVideoSettingProperties
  | StartKnowledgeCheckProperties
  | FinishedKnowledgeCheckProperties
  | StartQuizPoolProperties
  | FinishedQuizPoolProperties
  | OpenGlossaryTermProperties
  | SearchGlossaryTermProperties
